// Utility to convert numeric amounts to Indian Currency In-Words format

const ones = [
  '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
  'Seventeen', 'Eighteen', 'Nineteen'
];

const tens = [
  '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
];

function convertBelowThousand(num) {
  let str = '';
  if (num >= 100) {
    str += ones[Math.floor(num / 100)] + ' Hundred ';
    num %= 100;
  }
  if (num >= 20) {
    str += tens[Math.floor(num / 10)] + ' ';
    num %= 10;
  }
  if (num > 0) {
    str += ones[num] + ' ';
  }
  return str.trim();
}

export function numberToIndianWords(amount) {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return 'Zero Rupees Only';
  }

  const num = Number(amount);
  if (num === 0) return 'Zero Rupees Only';

  const parts = num.toFixed(2).split('.');
  let integerPart = parseInt(parts[0], 10);
  const decimalPart = parseInt(parts[1], 10);

  if (integerPart === 0 && decimalPart === 0) {
    return 'Zero Rupees Only';
  }

  let words = '';

  // Crores (>= 1,00,00,000)
  if (integerPart >= 10000000) {
    const crore = Math.floor(integerPart / 10000000);
    words += convertBelowThousand(crore) + ' Crore ';
    integerPart %= 10000000;
  }

  // Lakhs (>= 1,00,000)
  if (integerPart >= 100000) {
    const lakh = Math.floor(integerPart / 100000);
    words += convertBelowThousand(lakh) + ' Lakh ';
    integerPart %= 100000;
  }

  // Thousands (>= 1,000)
  if (integerPart >= 1000) {
    const thousand = Math.floor(integerPart / 1000);
    words += convertBelowThousand(thousand) + ' Thousand ';
    integerPart %= 1000;
  }

  // Hundreds & Remaining (< 1,000)
  if (integerPart > 0) {
    words += convertBelowThousand(integerPart) + ' ';
  }

  words = words.trim();
  let result = words ? `${words} Rupees` : '';

  if (decimalPart > 0) {
    const paiseWords = convertBelowThousand(decimalPart);
    result += result ? ` and ${paiseWords} Paise` : `${paiseWords} Paise`;
  }

  return `${result} Only`;
}

// Utility to format numbers into Indian Currency Display (e.g. 18,27,568.88 or 1.827.568,88 matching reference)
export function formatIndianCurrency(amount, useExactRefSeparator = false) {
  if (isNaN(amount) || amount === null || amount === undefined) return '0.00';
  const num = Number(amount);
  
  if (useExactRefSeparator) {
    // Reference format uses dots for thousands separator and comma for decimals: 1.827.568,88 or Indian standard 18,27,568.88
    // Let's support Indian standard ₹ 18,27,568.88 with 2 decimal places
    const [intPart, decPart] = num.toFixed(2).split('.');
    let lastThree = intPart.substring(intPart.length - 3);
    const otherNumbers = intPart.substring(0, intPart.length - 3);
    if (otherNumbers !== '') {
      lastThree = ',' + lastThree;
    }
    const formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;
    return `${formattedInt}.${decPart}`;
  }

  return num.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
